import AnalyticEventValues from '../../configs/hooks/analytics/analyticEventvalues';

const getPageviewValue = (pathname: string) => {
    if (pathname.startsWith('/analytics/key-theme-benchmarks')) {
        return AnalyticEventValues.embed_ktb;
    }

    if (pathname.startsWith('/analytics')) {
        return AnalyticEventValues.embed;
    }

    return undefined;
};

export default getPageviewValue;
